import React from "react";
import { classNames } from "../../common/util/util-helpers";

export default function FieldCheckbox({item = {}, onChange}) {
    return (
        <input
            className={classNames("checkbox", !!item.value ? "border-primary" : "border-tm-gray-400")}
            id={item?.props?.id ?? item.name}
            type="checkbox"
            name={item.name}
            checked={!!item.value && (item.value !== "0")}
            onChange={(event) => {
                onChange(item.name, !!event.target.checked);
            }}
            disabled={item.disabled}
        />
    )
}